module.exports = __webpack_public_path__ + "images/ynpk10wf.e266.png";